const userLabel = require("../label/user");

const note_comment_reply = {
  key: "note_comment_reply",
  count_alias: "count_comment_replies_new",
  label_activity: "comment replies",
  label_data: "new comment reply",
  label_detail: "A user replies to a comment I've posted.",
  label_title: () => "New Comment Reply",
  label_zero_state:
    "When a user replies to a comment you've posted, we'll notify you here.",
  makeNote: ({ isMentioned, ...user }) =>
    userLabel(user) +
    " replied to your comment" +
    (isMentioned ? " and mentioned you in it." : "."),
  makeLink: ({ id }) => "/comment/" + id,
  table: "comment",
  leftJoins: ["comment_reply", "author"],
  keys: [
    "comment.id AS id",
    "comment.created_at AS noted_at",
    "author.username AS username",
    "author.display_name AS display_name",
  ],
  wheres: ["comment_reply.author_id = ?", "comment.author_id <> ?"],
  where_since: {
    index: 1,
    sql: "comment.created_at >= ?",
    key: "note_last",
  },
  escapeValues: (user) => [user.id, user.id],
};

module.exports = note_comment_reply;
